<div nz-row style="font-size: 14px">
    <div nz-col nzSpan="4" class="ppl-read-label pt-2 pb-2">Authorized Dollars</div>
    <div nz-col nzSpan="4" class="pt-2 pb-2">{{authUtilizationData?.authUnit | currency}}</div>

    <div nz-col nzSpan="4" class="ppl-read-label pt-2 pb-2">Spent Dollars</div>
    <div nz-col nzSpan="4" class="pt-2 pb-2">{{authUtilizationData?.usedUnits | currency}}</div>

    <div nz-col nzSpan="4" class="ppl-read-label pt-2 pb-2">Remaining Dollars</div>
    <div nz-col nzSpan="4" class="pt-2 pb-2">{{authUtilizationData?.remainingUnits | currency}} </div>
</div>